import React from 'react';
import type { AaiRequest } from '../../types/aai';
import { Chip, Divided, ListRow, RouteMark } from '../../components/aa';
import type { ChipTone } from '../../components/aa';
import { relativeTime } from '../partner/format';

/*
 * A client's asks that are not a project yet, read by the provider that
 * serves it. Once a build exists the ask is listed as a project instead, so
 * the two lists never show the same work twice.
 */

const LABEL: Record<string, string> = {
  pending: 'With their department head',
  needs_info: 'Sent back for detail',
  dept_approved: 'Waiting on their owner',
  approved: 'Approved, not started',
  declined: 'Declined',
};

const TONE: Record<string, ChipTone> = {
  pending: 'neutral',
  needs_info: 'warn',
  dept_approved: 'warn',
  approved: 'ok',
  declined: 'err',
};

export const clientRequestLabel = (status?: string | null): string => LABEL[status || ''] || 'In review';

export const notBuiltYet = (rows: AaiRequest[]): AaiRequest[] =>
  rows.filter((r) => !r.builder_project_id && r.status !== 'declined');

export const ClientRequests: React.FC<{
  rows: AaiRequest[];
  showClient?: boolean;
  onOpen?: (r: AaiRequest) => void;
}> = ({ rows, showClient, onOpen }) => (
  <Divided>
    {rows.map((r) => (
      <ListRow
        key={r.id}
        mark={<RouteMark glyph={((showClient && r.company_name) || r.title || 'R').charAt(0).toUpperCase()} size="lg" />}
        kicker={showClient ? `For ${r.company_name || 'a client'}` : 'Request'}
        title={r.title}
        badge={<Chip tone={TONE[r.status || ''] || 'neutral'} dot>{clientRequestLabel(r.status)}</Chip>}
        meta={[
          { label: 'Asked by', value: r.requester_name || r.requester_email, foot: r.department || 'Whole company' },
          { label: 'Asked', value: relativeTime(r.created_at) || 'Not recorded' },
        ]}
        metaWidth={[220, 140]}
        onClick={onOpen ? () => onOpen(r) : undefined}
        arrow={!!onOpen}
      />
    ))}
  </Divided>
);
